<template>
  <div class="flex flex-col h-full overflow-hidden">
    <!-- Progress Indicator -->
    <report-progress :showProgress="isLoading" />

    <!-- Table Container with Sticky Header -->
    <div class="flex-1 overflow-hidden">
      <div class="h-full flex flex-col">
        <!-- Single Table with Sticky Header -->
        <div class="flex-1 overflow-auto">
          <table class="w-full table-auto text-sm">
            <thead class="sticky top-0 z-10">
              <tr>
                <th class="!bg-primary-900 text-white text-center font-weight-medium rounded-s-lg px-2 py-2">
                  {{ $t("reports.login_detail_report.head_ID") }}
                </th>
                <th class="!bg-primary-900 text-white text-center font-weight-medium px-2 py-2">
                  {{ $t("reports.login_detail_report.head_Name") }}
                </th>
                <th class="!bg-primary-900 text-white text-center font-weight-medium px-2 py-2">
                  {{ $t("reports.login_detail_report.head_Login") }}
                </th>
                <th class="!bg-primary-900 text-white text-center font-weight-medium px-2 py-2">
                  {{ $t("reports.login_detail_report.head_Logout") }}
                </th>
                <th class="!bg-primary-900 text-white text-center font-weight-medium rounded-e-lg px-2 py-2">
                  {{ $t("reports.login_detail_report.head_Staffed") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(record, index) in reportData" :key="record.user_id" 
                  :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                <td class="text-center text-grey-darken-1 px-2 py-2 border-b border-gray-200">
                  {{ formatNumber(record.uname) }}
                </td>
                <td class="text-center text-grey-darken-1 px-2 py-2 border-b border-gray-200">
                  {{ record.fullname }}
                </td>
                <td class="text-center text-grey-darken-1 px-2 py-2 border-b border-gray-200">
                  {{ formatDate(record.login_time) }}
                </td>
                <td class="text-center text-grey-darken-1 px-2 py-2 border-b border-gray-200">
                  {{
                    record.logout_time !== "-"
                      ? formatDate(record.logout_time)
                      : record.logout_time
                  }}
                </td>
                <td class="text-center text-grey-darken-1 px-2 py-2 border-b border-gray-200">
                  {{
                    record.staff_duration !== "-"
                      ? formatDuration(record.staff_duration)
                      : record.staff_duration
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportProgress from "../../components/ReportProgress.vue";
import { formatArabicDate, formatNumber, formatDuration } from "../../utils";

export default {
  name: "agent-login-report",
  components: {
    ReportProgress,
  },
  props: {
    selectedFilters: {
      type: Object,
      default: () => ({})
    },
    skills: {
      type: Array,
      default: () => []
    },
    reportData: {
      type: Array,
      default: () => []
    },
    totalCount: {
      type: Number,
      default: 0
    },
    showCount: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentLocal() {
      return this.$i18n.locale;
    },
  },
  methods: {
    formatDate(date) {
      const lang = this.$i18n.locale;
      return formatArabicDate(date, lang);
    },
    formatNumber(num) {
      const lang = this.$i18n.locale;
      return formatNumber(num, lang);
    },
    formatDuration(duration) {
      const lang = this.$i18n.locale;
      return formatDuration(duration, lang);
    },
  },
};
</script>

<style scoped></style>
